import type { TOptions } from 'video.js'
import type { Options } from '|>/core'

import { useMemo } from 'react'

/**
 * Hook to handle VideoJS options
 * For now just an example
 * Returns memoized options object, that will not change between renders
 */
export function useOptions({
  language,
  muted,
  autoplay,
  enableLowInitialPlaylist,
}: Options) {
  return useMemo(() => {
    return {
      language,
      muted,
      // double check to prevent autoplay true
      // should use any to allow autoplay with muted state after page reload
      autoplay: autoplay === true ? 'any' : autoplay,
      html5: {
        vhs: {
          enableLowInitialPlaylist,
        },
      },
    } satisfies TOptions
  }, [language, autoplay])
}
